import React from "react";
import { Link } from "react-router-dom";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Collapse,
  List,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserSecret,
  faCog,
  faChevronDown,
  faChevronUp,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "@mui/material/styles";
import { useAuth } from "../../../config/AuthContext";
import routeToPermission from "../../../config/routeToPermission";

const TechPrepInstructorLinks = () => {
  const [openSettings, setOpenSettings] = React.useState(false);
  const theme = useTheme();
  const { userPermissions } = useAuth();

  const handleSettingsToggle = () => {
    setOpenSettings(!openSettings);
  };

  // Helper to check permission
  const canView = (areaKey) => {
    const permissionName = routeToPermission[areaKey];
    return permissionName ? userPermissions[permissionName]?.view : false;
  };

  console.log("DEBUG userPermissions:", userPermissions);
  console.log(
    "DEBUG canView Course Catalog:",
    canView("TpPortalMgtCourseCatalog"),
  );

  return (
    <>
      {/* Users Link */}
      {canView("TpUsers") && (
        <ListItem sx={{ mt: 2, color: theme.palette.text.primary }}>
          <Link to="/TpUsers">
            <ListItemIcon>
              <FontAwesomeIcon
                icon={faUserSecret}
                style={{ color: "red", fontSize: "2rem" }}
              />
            </ListItemIcon>
          </Link>
          <Link to="/TpUsers">
            <ListItemText
              primary="Users"
              sx={{ color: theme.palette.text.primary }}
            />
          </Link>
        </ListItem>
      )}
      {/* School Users Link */}
      {canView("SchoolUsers") && (
        <ListItem sx={{ mt: 2, color: theme.palette.text.primary }}>
          <Link to="/SchoolUsers">
            <ListItemIcon>
              <FontAwesomeIcon
                icon={faUsers}
                style={{ color: "teal", fontSize: "2rem" }}
              />
            </ListItemIcon>
          </Link>
          <Link to="/SchoolUsers">
            <ListItemText
              primary="School Users"
              sx={{ color: theme.palette.text.primary }}
            />
          </Link>
        </ListItem>
      )}
      {/* Settings Section */}
      <ListItem
        sx={{
          justifyContent: "space-between",
          color: theme.palette.text.primary,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton onClick={handleSettingsToggle}>
            <FontAwesomeIcon
              icon={faCog}
              style={{ fontSize: "2rem", color: "orange" }}
            />
          </IconButton>
          <ListItemText primary="App Settings" onClick={handleSettingsToggle} />
        </div>
        <IconButton onClick={handleSettingsToggle}>
          <FontAwesomeIcon
            icon={openSettings ? faChevronUp : faChevronDown}
            style={{ fontSize: "1rem", color: "black" }}
          />
        </IconButton>
      </ListItem>
      <Collapse in={openSettings} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {canView("TpPortalMgtCourseCatalog") && (
            <ListItem
              component={Link}
              to="/TpPortalMgtCourseCatalog"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Course Catalog" />
            </ListItem>
          )}
          {canView("TpPortalMgtCourseShell") && (
            <ListItem
              component={Link}
              to="/TpPortalMgtCourseShell"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Course Shell" />
            </ListItem>
          )}
          {canView("TpCourseShellStatus") && (
            <ListItem
              component={Link}
              to="/TpCourseShellStatus"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Course Shell Status" />
            </ListItem>
          )}
          {canView("TpCreditTypes") && (
            <ListItem
              component={Link}
              to="/TpCreditTypes"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Credit Types" />
            </ListItem>
          )}
          {canView("TpCreditCapture") && (
            <ListItem
              component={Link}
              to="/TpCreditCapture"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Credit Capture" />
            </ListItem>
          )}
          {canView("TpCreditCaptureStatus") && (
            <ListItem
              component={Link}
              to="/TpCreditCaptureStatus"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Credit Capture Status" />
            </ListItem>
          )}
          {canView("TpCtag") && (
            <ListItem
              component={Link}
              to="/TpCtag"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Ctag" />
            </ListItem>
          )}
          {canView("TpPTPForms") && (
            <ListItem
              component={Link}
              to="/TpPTPForms"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="PTP Forms" />
            </ListItem>
          )}
          {canView("TpDeliveryDetails") && (
            <ListItem
              component={Link}
              to="/TpDeliveryDetails"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Delivery Details" />
            </ListItem>
          )}
          {canView("TpDivisions") && (
            <ListItem
              component={Link}
              to="/TpDivisions"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Divisions" />
            </ListItem>
          )}
          {canView("TpElearnShellTerm") && (
            <ListItem
              component={Link}
              to="/TpElearnShellTerm"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Elearn Shell Term" />
            </ListItem>
          )}
          {canView("TpFps") && (
            <ListItem
              component={Link}
              to="/TpFps"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="FPS" />
            </ListItem>
          )}
          {canView("TpFpsCourses") && (
            <ListItem
              component={Link}
              to="/TpFpsCourses"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="FPS Courses" />
            </ListItem>
          )}
          {canView("TpHeiPrograms") && (
            <ListItem
              component={Link}
              to="/TpHeiPrograms"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="HEI Programs" />
            </ListItem>
          )}
          {canView("TpPartners") && (
            <ListItem
              component={Link}
              to="/TpPartners"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Partners" />
            </ListItem>
          )}
          {canView("TpPathwayPrograms") && (
            <ListItem
              component={Link}
              to="/TpPathwayPrograms"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Pathway Programs" />
            </ListItem>
          )}
          {canView("TpResidenceStatusCodes") && (
            <ListItem
              component={Link}
              to="/TpResidenceStatusCodes"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Residence Status Codes" />
            </ListItem>
          )}
          {canView("TpShellStatus") && (
            <ListItem
              component={Link}
              to="/TpShellStatus"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Shell Status" />
            </ListItem>
          )}
          {canView("TpSites") && (
            <ListItem
              component={Link}
              to="/TpSites"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Sites" />
            </ListItem>
          )}
          {canView("TpSsnStatusCode") && (
            <ListItem
              component={Link}
              to="/TpSsnStatusCode"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="SSN Status Code" />
            </ListItem>
          )}
          {canView("TpStudents") && (
            <ListItem
              component={Link}
              to="/TpStudents"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Students" />
            </ListItem>
          )}
          {canView("ProgramDelivery") && (
            <ListItem
              component={Link}
              to="/ProgramDelivery"
              onClick={handleSettingsToggle}
              sx={{ pl: 4, color: theme.palette.text.primary }}
            >
              <ListItemText primary="Program Delivery" />
            </ListItem>
          )}
        </List>
      </Collapse>
    </>
  );
};

export default TechPrepInstructorLinks;
